import type React from "react";
import { cn } from "@/lib/utils";
import { iconConfig } from "../icon.config";

interface BaseIconProps extends React.SVGProps<SVGSVGElement> {
	title?: string;
	size?: number;
}

export const BaseIcon: React.FC<BaseIconProps> = (props) => {
	const {
		className,
		title,
		size,
		fill,
		stroke,
		role = "img",
		children,
		"aria-label": ariaLabel,
		...otherProps
	} = props;

	const {
		defaultStyle,
		defaultFill,
		defaultStroke,
		size: defaultSize,
	} = iconConfig;

	return (
		<svg
			className={cn(defaultStyle, className)}
			fill={fill ?? defaultFill}
			viewBox="0 0 16 16"
			stroke={stroke ?? defaultStroke}
			width={size ?? defaultSize}
			height={size ?? defaultSize}
			role={role}
			aria-label={ariaLabel || title}
			{...otherProps}
		>
			{title && <title>{title}</title>}
			{children}
		</svg>
	);
};
